var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "videoMessage" },
    [
      _c("custom-video-player", {
        ref: "videoPlayer",
        staticClass: "video-player-box",
        attrs: {
          src: _vm.videoSrc(),
          "max-width": 400,
          "max-height": 300,
          "playback-rates": [0.7, 1.0, 1.5, 2.0],
          muted: false,
          timestamp: _vm.displayTimestamp,
          "timestamp-tooltip": _vm.timestampTooltip,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }